import SpriteSymbol from "../../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "common-arrow_up",
  "use": "common-arrow_up-usage",
  "viewBox": "0 0 12 13",
  "content": "<symbol viewBox=\"0 0 12 13\" xmlns=\"http://www.w3.org/2000/svg\" id=\"common-arrow_up\"><path d=\"M6 11.5V1.5M6 1.5L1 6.5M6 1.5L11 6.5\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol